export class LocalStrageRepository {
  public save(key:string, value:string):void {
    localStorage.setItem(key, value);
  }

  public get(key: string): string {
    return localStorage.getItem(key)!;
  }
}